// export const API_BASE   = "http://172.16.12.22:3001/admin";
// export const IMAGE_BASE = 'http://172.16.12.22:3001/';

// export const API_BASE = "http://172.16.11.1:3001/admin"
// export const IMAGE_BASE = "http://172.16.11.1:3001/"

export const API_BASE = "https://chatapp-api.devtechnosys.tech/admin";
export const IMAGE_BASE = "https://chatapp-api.devtechnosys.tech/";

export const BASE_API = API_BASE + "/admin";
export const MAIN_URL = BASE_API + "/api/admin";
export const MOBILE_REGEX = /^[0-9]{6,15}$/;

export const PASSWORDS_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%^&*?])[A-Za-z\d#$@!%^&*?]{8,}$/;

export const EMAIL_REGEX =
  /^(?![.+-])([a-zA-Z0-9._+-]+)(?!\.)[a-zA-Z0-9]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
export const NOSPACE_REGEX = /^[^\s](?:.*[^\s])?$/;

export const REMOVENBSP = /&nbsp;/g

export const NOSPACE = "Spaces are not allowed";

export const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "video/mp4",
  "video/x-ms-wmv",
  "video/quicktime",
  "video/webm",
  "application/pdf",
  "text/plain",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const MULTIPLESPACE = /  +/g;

export const CARD_REGEX =
  /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/g;

export const NODIGITREGEX = /^([^0-9]*)$/;

export const DECIMALPATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;

export const REMOVEHTML = /(<([^>]+)>)/gi;
export const URL_REGEX = /^(https?:\/\/)?([^\s:@]+:[^\s:@]*@)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|localhost|(\d{1,3}\.){3}\d{1,3})(:\d+)?(\/[^\s]*)?$/;

export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const STATUS_OPTIONS = [
  { value: false, label: "Active" },
  { value: true, label: "Inactive" },
];

export const STATUS_OPTIONS_LIST = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];
export const STATUS_OPTIONS_LIST1 = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
  { value: 3, label: "Self Exclude" },
];
export const Verification_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "cancelled", label: "Cancelled" },
];
export const PLAN_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

export const TRANSACTIONTYPE_TYPE = [
  { value: "credit", label: "Deposits" },
  { value: "debit", label: "Withdrawals" },
  { value: "winning-price", label: "Winnings" },
  { value: "referral", label: "Refferal" },
  
];

export const positionActionsMap = {
  24: [
      { value: "save", label: "Save" },
      { value: "clearance", label: "Clearance" },
      { value: "distribution", label: "Distribution" },
  ],
  25: [
      { value: "tackle", label: "Tackle" },
      { value: "interception", label: "Interception" },
      { value: "block", label: "Block" },
  ],
  26: [
      { value: "assist", label: "Assist" },
      { value: "key-pass", label: "Key Pass" },
      { value: "dribble", label: "Dribble" },
  ],
  27: [
      { value: "goal", label: "Goal" },
      { value: "shot-on-target", label: "Shot on Target" },
      { value: "offside", label: "Offside" },
  ],
};